// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__mzmVs","content":"styles_content__3Evf_","selectAll":"styles_selectAll__2jrlX"};